export const WEEK = 7;
export const MONTH = 30;

export default { WEEK, MONTH };
